import { Protocol } from "shared/models";
import * as i18n from 'i18next';

const protocols: Record<string, string[]> = {
    "RS485": [
        "DMG_EQ",
        "DMG_RS485",
        "DELBO",
        "KW",
    ],
    "PARALLEL": [
        "3WIRE",
        "1XP",
        "1XS",
        "Autinor",
        "BINARY",
        "GRAY",
        "SensorManual",
        "SensorAuto",
        "TKE",
        "MEA_1", // MEA_QTOUCH
        "MEA_2", // MEA_NG120
    ],
    "CAN": [
        "CAN_DMG",
        "CAN_IGV",
        "CAN_MOVILIFT",
        "CAN_TRESA",
    ],
    "CAN_V2": [
        "CAN_DMG_V2",
        "CAN_EC",
        "CAN_EDEL",
        "CAN_GAL",
        "CAN_JRT",
        "CAN_KOMP",
        "CAN_MACPUAR",
        "CAN_STEP",
        "CAN_TKEUS",
        "CAN_TKNE",
        "CAN_SMARTRISE",
        "CAN_ALPHA",
        "CAN_SEA",
        "CAN_LIFTING",
    ],
    "OTIS": [
        "OTIS_STD",
    ],
    "KINDS": [
        "KINDS_STD",
    ],
    "FIGS_BIOBUS": [
        "BIOBUS",
    ],
    "FIGS_CAN": [
        "FIGS_CAN",
    ],
    "SCH_FLOOR_GRAY": [
        "SCH_FLOOR_GRAY",
    ],
    "MX_BASIC": [
        "MX_BASIC",
    ],
    "CANOPEN": [
        "CiA417",
        "SCH_CAR",
    ],
};


export function isKnownProtocol(_interface: string, subInterface: string | null): boolean {
    const subInterfaces = protocols[_interface.toUpperCase()];
    if (!subInterfaces) return false;
    return subInterfaces
        .map(subinterface => subinterface.toUpperCase())
        .indexOf((subInterface || '').toUpperCase()) >= 0;
}

export function isKnownInterface(_interface: string): boolean {
    return !!protocols[_interface.toUpperCase()];
}

export function getKnownInterfaces(): string[] {
    return Object.keys(protocols);
}

export function getKnownSubInterfaces(_interface: string): string[] {
    return protocols[_interface.toUpperCase()];
}

const identity = (errorKey: string) => errorKey;
export const getErrorByProtocol = (protocol: Protocol | null, t: i18n.TFunction = identity) => {
    if (!protocol) return '';
    if (!isKnownProtocol(protocol.interface, protocol.subinterface)) {
        return t('ERROR.UNKNOWN_PROTOCOL');
    }
    if (!isKnownInterface(protocol.interface)) {
        return t('ERROR.EXPECTING_INTERFACE', [ getKnownInterfaces().join(', ') ]);
    }
    if (isKnownInterface(protocol.interface) && !isKnownProtocol(protocol.interface, protocol.subinterface)) {
        return t('ERROR.EXPECTING_SUBVAR', [ getKnownSubInterfaces(protocol.interface).join(', ') ]);
    }
    return '';
};